var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporateStyle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 36,
    viewBox: "0 0 82 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 29.0436V35.9977C5.55799 35.8798 10.0279 31.2608 10.0279 25.5801V11.7899C10.0279 8.50448 12.106 6.94947 13.4403 6.94947C14.7746 6.94947 16.8527 8.50448 16.8527 11.7899V24.2101C16.8527 30.1093 20.8896 36 27.0984 36C33.3073 36 37.3442 30.1093 37.3442 24.2101V11.7899C37.3442 8.50448 39.4222 6.94947 40.7566 6.94947C42.0909 6.94947 44.169 8.50448 44.169 11.7899V24.2101C44.169 30.1093 48.2058 36 54.4147 36C60.6235 36 64.6604 30.1093 64.6604 24.2101V11.7899C64.6604 8.50448 66.7385 6.94947 68.0728 6.94947C69.4072 6.94947 71.4852 8.50449 71.4852 11.7899V24.2101C71.4852 30.1093 75.5221 36 81.7309 36C81.8211 36 81.9108 35.9988 82 35.9963V29.0307C81.9077 29.044 81.8177 29.0505 81.7309 29.0505C80.3966 29.0505 78.3185 27.4955 78.3185 24.2101V11.7899C78.3185 5.89065 74.2816 0 68.0728 0C61.864 0 57.8271 5.89066 57.8271 11.7899V24.2101C57.8271 27.4955 55.749 29.0505 54.4147 29.0505C53.0804 29.0505 51.0023 27.4955 51.0023 24.2101V11.7899C51.0023 5.89066 46.9654 0 40.7566 0C34.5477 0 30.5108 5.89066 30.5108 11.7899V24.2101C30.5108 27.4955 28.4328 29.0505 27.0984 29.0505C25.7641 29.0505 23.686 27.4955 23.686 24.2101V11.7899C23.686 5.89066 19.6492 0 13.4403 0C7.23147 0 3.19458 5.89066 3.19458 11.7899V25.5801C3.19458 27.4224 1.78312 28.9293 0 29.0436Z",
    fill: "url(#paint0_linear_740_5449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5449",
    x1: 18.9722,
    y1: 20.354,
    x2: 81.4107,
    y2: 20.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateStyle1);
export default __webpack_public_path__ + "static/media/corporate-style-1.8da87f860b402a15d212eadf0e867ab7.svg";
export { ForwardRef as ReactComponent };